class ReadyToShipToggle extends HTMLElement {
  // Shopify's native /collections/<handle>/<tag> URL filters by tag
  // directly — no Search & Discovery "Product tag" filter needs to be
  // enabled for this to work, unlike the old ?filter.p.tag= query param
  // approach, which silently did nothing if that filter wasn't turned on
  // for the collection.
  static tagHandle = 'readytoship';

  connectedCallback() {
    this.input = this.querySelector('[data-ready-to-ship-input]');
    if (!this.input) return;

    this.input.checked = this.isActiveInLocation();
    this.input.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.onChange);
  }

  isActiveInLocation() {
    return this.pathSegments(window.location.pathname).pop() === ReadyToShipToggle.tagHandle;
  }

  pathSegments(pathname) {
    return pathname.split('/').filter(Boolean);
  }

  // The current path with any existing /readytoship segment removed.
  basePath() {
    const segments = this.pathSegments(window.location.pathname);
    if (segments[segments.length - 1] === ReadyToShipToggle.tagHandle) segments.pop();
    return `/${segments.join('/')}`;
  }

  onChange = () => {
    const checked = this.input.checked;
    const base = this.basePath();
    const targetPath = checked ? `${base}/${ReadyToShipToggle.tagHandle}` : base;
    const searchParams = window.location.search.slice(1);

    FacetFiltersForm.renderPage(searchParams, null, true, targetPath);

    // More than one instance of this toggle can be on the page at once
    // (e.g. the sticky bottom one and another inside the filter drawer) —
    // keep them all showing the same state as whichever one was just used.
    document.querySelectorAll('ready-to-ship-toggle').forEach((toggle) => {
      if (toggle !== this && toggle.input) toggle.input.checked = checked;
    });
  };
}

customElements.define('ready-to-ship-toggle', ReadyToShipToggle);
